import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import checkmark from "../../assets/Icons/SVG/check-mark.svg";
import "./OptionsCards.css";
import ListGroup from "react-bootstrap/ListGroup";
import React, { useEffect, useState } from "react";
import mostPopular from "../../assets/Images/Lable - Most Popular.png";
import QuickTELOrangeColor from "../../assets/Logos/QuickTELOrangeColor 1.png";
import Ontelllus from "../../assets/Logos/Ontelllus-logo.png";
import SocialCanvassLogo from "../../assets/Logos/Social Canvass Logo Tagline 1.png";
import greycheckmark from "../../assets/Icons/PNG/Check Mark_Gray.png";
import { FileInput } from "../FileInput/FileInput";

const OptionsCards = ({
  options,
  selectedOption,
  selectedMedicalCanvassOptions,
  onCheckboxChange,
  onUploadFile,
  onRemoveFile,
  uploadedFilesNames,
  canUploadLocationFile,
  updateLocations,
  formData,
  setFormData,
  isLocationOtherSelected,
  isLocationOtherTextOk
}) => {
  const [isExpressSelected, setIsExpressSelected] = useState(
    selectedMedicalCanvassOptions?.some((opt) => opt.id === 0)
  );
  
  const [isStandardSelected, setIsStandardSelected] = useState(
    selectedMedicalCanvassOptions?.some((opt) => opt.id === 1)
  );

  const [isDontwantMediaclSelected, setIsDontwantMediaclSelected] = useState(
    selectedMedicalCanvassOptions?.some((opt) => opt.id === 2)
  );

  useEffect(() => {
    setIsExpressSelected(selectedMedicalCanvassOptions?.some((opt) => opt.id === 0))
    setIsStandardSelected(selectedMedicalCanvassOptions?.some((opt) => opt.id === 1))
    setIsDontwantMediaclSelected(selectedMedicalCanvassOptions?.some((opt) => opt.id === 2))
  }, [selectedMedicalCanvassOptions])

  const disabledLocations = ["Pharmacy", "Hospital"];
  const chunkedLocations = chunkArray(options[1].locations, 7);
  const [error, setError] = useState("");

  function chunkArray(array, chunkSize) {
    return Array.from(
      { length: Math.ceil(array.length / chunkSize) },
      (_, index) =>
        array.slice(index * chunkSize, index * chunkSize + chunkSize)
    );
  }

  const handleCheckboxChange = (option) => {
    onCheckboxChange(option);
    setIsExpressSelected(option.id === 0);
    setIsStandardSelected(option.id === 1);
    setIsDontwantMediaclSelected(option.id === 2);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      medicalCanvassing: {
        ...prevData.medicalCanvassing,
        [name]: value,
      },
    }));
  };
  
  useEffect(() => {
    if (isLocationOtherTextOk || isDontwantMediaclSelected) {
        setError("");
    } else {
        setError("This field is required.");
    }
  }, [isLocationOtherTextOk, isDontwantMediaclSelected]);
  
  return (
    <>
      {options.map((option) => (
        <Row key={option.id} className="mb-4">
          <Col>
            <Card className="Card-color">
              <Card.Body>
                <Row className="mb-3">
                  <Col xs="auto" className="d-flex align-items-center">
                    <Form.Check
                      className="custom-checkbox .form-check-input"
                      type="checkbox"
                      id={`option${option.id}`}
                      checked={
                        selectedOption?.title === option.title || selectedMedicalCanvassOptions?.some((opt) => opt.id === option.id)
                      }
                      onChange={() => {
                        handleCheckboxChange(option);
                      }}
                    />
                  </Col>
                  <Col className="d-flex align-items-center">
                    <h3 className="mb-0" id={`option${option.title}`}>{`${option.title}`}</h3>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Card.Text style={{ marginBottom: "10px" }}>
                      {option.description}
                    </Card.Text>
                  </Col>
                </Row>
                <Row>
                  {"  \n \n "}
                  <Col>
                    <ListGroup
                      style={{
                        listStyleType: "none",
                        padding: "0",
                        margin: "0",
                      }}
                    >
                      {option.features.map((feature, index) => (
                        <li
                          key={index}
                          className={`${
                            feature.isDisabled ? "line-through" : "feature"
                          }`}
                        >
                          <img
                            src={`${
                              feature.isDisabled ? greycheckmark : checkmark
                            }`}
                            alt="Checkmark Icon"
                          />{" "}
                          <span className="bold-text">{feature.title}</span>{" "}
                        </li>
                      ))}
                    </ListGroup>
                  </Col>
                </Row>

                <Row>
                  {option.header && (
                    <header className="header-color">{option.header}</header>
                  )}
                </Row>
                {option.id === 0 && (
                  <div className="card-images">
                    <img
                      src={mostPopular}
                      alt="Upload Icon 1"
                      className="icon top-icon"
                    />
                    <img
                      src={QuickTELOrangeColor}
                      alt="Upload Icon 2"
                      className="icon bottom-icon"
                    />
                  </div>
                )}
                {option.id === 5 && (
                  <div className="card-images">
                    <img
                      src={SocialCanvassLogo}
                      alt="Upload Icon 2"
                      className="icon bottom-icon"
                    />
                  </div>
                )}
                {option.id === 3 && (
                  <div className="card-images">
                    <img
                      src={Ontelllus}
                      alt="Upload Icon 2"
                      className="icon bottom-icon-Ontelllus"
                    />
                  </div>
                )}
                {(option.id === 3 ||
                  (option.id === 1 && canUploadLocationFile)) && (
                  <Row>
                    {canUploadLocationFile && (
                      <Col md={12}>
                        <p className="mt-2 mb-0"  id="medical-authorization-warning">
                          <span style={{ color: "red" }}>* </span>A Medical
                          Authorization is required for this Provider Location
                          Type
                        </p>
                      </Col>
                    )}
                    <FileInput
                      uploadedFilesNames={uploadedFilesNames}
                      onUploadFile={onUploadFile}
                      onRemoveFile={onRemoveFile}
                      disabled={
                        selectedOption?.id !== 3 &&
                        !selectedMedicalCanvassOptions?.some((opt) => opt.id === 0) &&
                        !selectedMedicalCanvassOptions?.some((opt) => opt.id === 1)
                      }
                      isRequired={
                        (option.id === 1 && canUploadLocationFile) ||
                        selectedOption?.id === 3
                      }
                    />
                  </Row>
                )}
                <Row>
                  {option.locations.length > 0 && (
                    <Form>
                      <Row className="m-2">
                        {chunkedLocations.map((chunk, columnIndex) => (
                          <Col key={columnIndex}>
                            {chunk.map((location) => (
                              <Form.Check
                                key={location.id}
                                type="checkbox"
                                id={`location-checkbox-${location.id}`}
                                onChange={() => {
                                  updateLocations(location.id);
                                }}
                                checked={
                                  !selectedMedicalCanvassOptions?.some((opt) => opt.id === 2) &&
                                  location.isSelected &&
                                  !(
                                    isExpressSelected &&
                                    disabledLocations.includes(location.title)
                                  )
                                }
                                label={
                                  <span className="custom-checkbox-label">
                                    {location.title}
                                  </span>
                                }
                                disabled={
                                  (isExpressSelected &&
                                    disabledLocations.includes(
                                      location.title
                                    )) ||
                                  location.disabled ||
                                  selectedMedicalCanvassOptions?.some((opt) => opt.id === 2)
                                }
                              />
                            ))}
                          </Col>
                        ))}
                        {isStandardSelected &&
                          option.locations.filter((e) => e.isSelected).length <=
                            0 && (
                            <p style={{ color: "red" }} id ="error-location-message">
                              Must select at least one Provider Location Type.
                            </p>
                          )}

                        {isLocationOtherSelected && (
                          <Row className="mt-2">
                            <Form>
                              <Form.Label>Other Details</Form.Label>
                              <Form.Control
                                as="textarea"
                                rows={2}
                                placeholder="Enter details here"
                                value={formData["other"]}
                                name="other"
                                id="other"
                                onChange={handleChange}
                                className="form-control-custom"
                                disabled={selectedMedicalCanvassOptions?.some((opt) => opt.id === 2)}
                              />
                              {(error && option.id !==2) && (
                                <Form.Text id="other-error" className="error">{error}</Form.Text>
                              )}
                            </Form>
                          </Row>
                        )}
                      </Row>
                    </Form>
                  )}
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      ))}
    </>
  );
};
export default OptionsCards;
